import { http } from ".";

export interface GoogleAuth {
  id_token: string;
}
export async function requestGoogleAuth(code: string) {
  return http.post<GoogleAuth>("/auth/google/", { id_token: code, "platform":"web" });
}
